import axios from 'axios'

export default {
  namespaced: true,
  state: {
    total_day: 12,
  },
  getters: {
    total_day(state) {
      return state.total_day
    }
  },
  mutations: {
    SET_TOTAL_DAY(state, value) {
      state.total_day = value
    }
  },
  actions: {
    async postRule({ commit }) {
      try {
        const response = await axios.get("/api/frontend_padel/rules/single");
        commit('SET_TOTAL_DAY', (parseInt(response.data.total_days)));
      } catch (error) {
        console.log(error);
        commit('SET_TOTAL_DAY', 12);
      }
    }
    // postRule({ commit }) {
    //   return axios.get('/api/frontend_padel/rules/single').then(({ data }) => {
    //     commit('SET_TOTAL_DAY', (parseInt(data.total_days) - 1));
    //   }).catch(({ response: { data } }) => {
    //     commit('SET_TOTAL_DAY', 12);
    //   })
    // }
  }
}